import * as React from 'react';
import { Link } from 'react-router-dom';
import Project from 'src/entities/Project';
import ImageContainer from 'src/modules/commons/images/Image.container';

interface Props {
  project: Project;
}

const ProjectSimpleCardComponent: React.StatelessComponent<Props> = (props: Props) => (
  <div className="project-card" style={{margin: '0 5px 5px 0'}}>
    <Link to={'/ficha-de-operaciones/' + props.project.id}>
      <div className="image-simple">
        <ImageContainer
          alt={props.project.company.name + ' logo'}
          className="img-responsive"
          url={props.project.company.logo}
        />
      </div>
      <div className="content">
        <h3>
          {props.project.company.name}
        </h3>
        <p
          style={{
            display: 'block',
            textOverflow: 'ellipsis',
            wordWrap: 'break-word',
            overflow: 'hidden',
            lineHeight: '1.43em',
            maxHeight: '7.15em'
          }}
        >
          {props.project.company.description}
        </p>
      </div>
      <div className="row">
        <p className="lead c-black-text text-center margin-bottom-0">
          {props.project.cash.toLocaleString('es')} €
        </p>
      </div>
      <hr/>
      <p className="text-center f-s-22 c-grey f-w-100">
        Financiado
      </p>
    </Link>
  </div>
);

export default ProjectSimpleCardComponent;


// WEBPACK FOOTER //
// ./src/modules/projects/partials/ProjectSimpleCard.component.tsx